// extracted by mini-css-extract-plugin
export default {"copy":"a_b","event-form":"a_c","event-form_content":"a_e","event-form_resizeble":"a_f","event-form_left-side":"a_g","event-form_right-side":"a_h"};